export function StringData() {
    return {
        name: "string",
        label: "String",
        primitiveType: "string"
    };
}

export default StringData;
